<template>
  <component :is="component" class="py-10 py-md-13 py-lg-16">
    <div class="text-center">
      <TitleWidget v-if="title">{{ title }}</TitleWidget>
    </div>

    <LoadingWidget v-if="loading" class="py-10 py-md-13 py-lg-16" />

    <template v-else>
      <slot />
    </template>
  </component>
</template>

<script>
import LoadingWidget from "../widgets/LoadingWidget.vue";
import TitleWidget from "../widgets/TitleWidget.vue";
import { VContainer } from "vuetify/lib/components";

export default {
  props: {
    title: String,
    loading: {
      type: Boolean,
      default: false,
    },
    container: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    component() {
      return this.container ? "v-container" : "div";
    },
  },
  components: {
    LoadingWidget,
    TitleWidget,
    VContainer,
  },
};
</script>
